import { useLoader } from './LoaderContext';
import { CircularProgress, Box } from '@mui/material';

export const GlobalLoader = () => {
  const { loading } = useLoader();

  if (!loading) return null;

  return (
    <Box
      position="fixed"
      top={0}
      left={0}
      right={0}
      bottom={0}
      display="flex"
      alignItems="center"
      justifyContent="center"
      bgcolor="rgba(255, 255, 255, 0.7)"
      zIndex={2000}
    >
      <CircularProgress />
    </Box>
  );
};
